var path = '/components/directives/customfield/select-box.tpl.html';
var html = "<label for=\"{{name}}\" ng-if=\"field.definition.name\">{{::field.definition.name}}\n    <span ng-if=\"field.definition.required\">*</span>\n    <i class=\"fal fa-info-circle\" ng-if=\"field.definition.tooltip\">\n        <span data-tooltip=\"{{::field.definition.tooltip}}\"></span>\n    </i>\n</label>\n<p class=\"help-text\" ng-if=\"field.definition.help\">{{::field.definition.help}}</p>\n\n<select-box\n        model=\"field.ngModel\"\n        name=\"{{name}}\"\n        config=\"field.definition.config\">\n</select-box>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/directives/customfield/select-box.tpl.html
// module id = 1999
// module chunks = 1